// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/OAuthConnections.module.css */

.OAuthConnections_container__Te2Od {
  padding: 24px;
  max-width: 1080px;
  margin: 0 auto;
}

/* ------------------------------------------------------------------ */
/* Header                                                              */
/* ------------------------------------------------------------------ */

.OAuthConnections_headerRow__0VAEl {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
}

.OAuthConnections_title__FH-yz {
  font-size: 22px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 6px 0;
}

.OAuthConnections_subtitle__dCm8t {
  font-size: 13px;
  color: #718096;
  margin: 0;
  line-height: 1.55;
  max-width: 640px;
}

/* ------------------------------------------------------------------ */
/* Loading                                                             */
/* ------------------------------------------------------------------ */

.OAuthConnections_loadingBlock__QNCvQ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px;
  color: #718096;
  font-size: 14px;
}

.OAuthConnections_spin__t38JN {
  animation: OAuthConnections_oauthSpin__tOqFj 1.1s linear infinite;
  color: #4299e1;
}

@keyframes OAuthConnections_oauthSpin__tOqFj {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ------------------------------------------------------------------ */
/* Sections                                                            */
/* ------------------------------------------------------------------ */

.OAuthConnections_section__yYNXj {
  margin-bottom: 28px;
}

.OAuthConnections_sectionTitle__X-Un- {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #4a5568;
  margin-bottom: 12px;
}

.OAuthConnections_emptyHint__7ITH0 {
  padding: 16px;
  background: #f7fafc;
  border: 1px dashed #cbd5e0;
  border-radius: 8px;
  font-size: 13px;
  color: #718096;
  text-align: center;
}

/* ------------------------------------------------------------------ */
/* Active connections list                                             */
/* ------------------------------------------------------------------ */

.OAuthConnections_connectionList__mDOtB {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.OAuthConnections_connectionCard__THEBo {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.OAuthConnections_connectionCard__THEBo:hover {
  border-color: #cbd5e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.OAuthConnections_connectionIconWrap__CDd-r {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.OAuthConnections_connectionIcon__WjQ3m {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.OAuthConnections_connectionIconFallback__aKUdO {
  color: #a0aec0;
}

.OAuthConnections_connectionBody__LQ\\+zh {
  flex: 1 1;
  min-width: 0;
}

.OAuthConnections_connectionLine1__C8Y8v {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.OAuthConnections_connectionAccount__q4gbC {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  word-break: break-all;
}

.OAuthConnections_badgeApp__5rG1p {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 10px;
  background: #ebf8ff;
  color: #2b6cb0;
  border: 1px solid #bee3f8;
}

.OAuthConnections_badgeTenant__ytjoY {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #faf5ff;
  color: #6b46c1;
  border: 1px solid #e9d8fd;
}

.OAuthConnections_connectionLine2__92bbS {
  font-size: 12px;
  color: #4a5568;
  margin-bottom: 4px;
}

.OAuthConnections_connectionLine3__LnM8P {
  font-size: 11px;
  color: #a0aec0;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.OAuthConnections_dot__gImRy {
  color: #cbd5e0;
}

.OAuthConnections_scopesRow__YeRmL {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.OAuthConnections_scopeChip__D7Up6 {
  font-size: 11px;
  color: #2d3748;
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  padding: 2px 8px;
  border-radius: 10px;
  line-height: 1.4;
}

.OAuthConnections_scopeChipMuted__paUUX {
  font-size: 11px;
  color: #a0aec0;
  padding: 2px 8px;
  border-radius: 10px;
  line-height: 1.4;
}

.OAuthConnections_connectionActions__3usvt {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.OAuthConnections_disconnectBtn__zwfnV {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #c53030;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.OAuthConnections_disconnectBtn__zwfnV:hover {
  background: #fff0f0;
  border-color: #fc8181;
}

/* ------------------------------------------------------------------ */
/* Available providers grid                                            */
/* ------------------------------------------------------------------ */

.OAuthConnections_providerGrid__LyaFU {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
}

.OAuthConnections_providerCard__eHXLh {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.15s ease;
}

.OAuthConnections_providerCard__eHXLh:hover {
  border-color: #cbd5e0;
}

.OAuthConnections_providerIconWrap__sjNMd {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.OAuthConnections_providerIcon__HKPSH {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.OAuthConnections_providerIconFallback__wNsZd {
  color: #a0aec0;
}

.OAuthConnections_providerBody__gMBEX {
  flex: 1 1;
  min-width: 0;
}

.OAuthConnections_providerName__dGYOI {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 6px;
}

.OAuthConnections_providerScopes__Gdmsr {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.OAuthConnections_connectBtn__MApsi {
  flex-shrink: 0;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: #4299e1;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
}

.OAuthConnections_connectBtn__MApsi:hover {
  background: #3182ce;
}

/* ------------------------------------------------------------------ */
/* Footnote                                                            */
/* ------------------------------------------------------------------ */

.OAuthConnections_footnote__cSP8K {
  margin-top: 12px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #718096;
  line-height: 1.55;
  padding: 10px 12px;
  background: #f7fafc;
  border-radius: 6px;
}

.OAuthConnections_footnote__cSP8K svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #a0aec0;
}

/* ------------------------------------------------------------------ */
/* Responsive                                                          */
/* ------------------------------------------------------------------ */

@media (max-width: 640px) {
  .OAuthConnections_container__Te2Od {
    padding: 16px;
  }

  .OAuthConnections_connectionCard__THEBo {
    flex-wrap: wrap;
  }

  .OAuthConnections_connectionActions__3usvt {
    width: 100%;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .OAuthConnections_providerGrid__LyaFU {
    grid-template-columns: 1fr;
  }

  .OAuthConnections_providerCard__eHXLh {
    flex-wrap: wrap;
  }

  .OAuthConnections_connectBtn__MApsi {
    width: 100%;
    margin-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/OAuthConnections.module.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iEAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/OAuthConnections.module.css */\n\n.container {\n  padding: 24px;\n  max-width: 1080px;\n  margin: 0 auto;\n}\n\n/* ------------------------------------------------------------------ */\n/* Header                                                              */\n/* ------------------------------------------------------------------ */\n\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #1a202c;\n  margin: 0 0 6px 0;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: #718096;\n  margin: 0;\n  line-height: 1.55;\n  max-width: 640px;\n}\n\n/* ------------------------------------------------------------------ */\n/* Loading                                                             */\n/* ------------------------------------------------------------------ */\n\n.loadingBlock {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px;\n  color: #718096;\n  font-size: 14px;\n}\n\n.spin {\n  animation: oauthSpin 1.1s linear infinite;\n  color: #4299e1;\n}\n\n@keyframes oauthSpin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* ------------------------------------------------------------------ */\n/* Sections                                                            */\n/* ------------------------------------------------------------------ */\n\n.section {\n  margin-bottom: 28px;\n}\n\n.sectionTitle {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #4a5568;\n  margin-bottom: 12px;\n}\n\n.emptyHint {\n  padding: 16px;\n  background: #f7fafc;\n  border: 1px dashed #cbd5e0;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #718096;\n  text-align: center;\n}\n\n/* ------------------------------------------------------------------ */\n/* Active connections list                                             */\n/* ------------------------------------------------------------------ */\n\n.connectionList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.connectionCard {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.connectionCard:hover {\n  border-color: #cbd5e0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.connectionIconWrap {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.connectionIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.connectionIconFallback {\n  color: #a0aec0;\n}\n\n.connectionBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.connectionLine1 {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.connectionAccount {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a202c;\n  word-break: break-all;\n}\n\n.badgeApp {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #ebf8ff;\n  color: #2b6cb0;\n  border: 1px solid #bee3f8;\n}\n\n.badgeTenant {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #faf5ff;\n  color: #6b46c1;\n  border: 1px solid #e9d8fd;\n}\n\n.connectionLine2 {\n  font-size: 12px;\n  color: #4a5568;\n  margin-bottom: 4px;\n}\n\n.connectionLine3 {\n  font-size: 11px;\n  color: #a0aec0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.dot {\n  color: #cbd5e0;\n}\n\n.scopesRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.scopeChip {\n  font-size: 11px;\n  color: #2d3748;\n  background: #edf2f7;\n  border: 1px solid #e2e8f0;\n  padding: 2px 8px;\n  border-radius: 10px;\n  line-height: 1.4;\n}\n\n.scopeChipMuted {\n  font-size: 11px;\n  color: #a0aec0;\n  padding: 2px 8px;\n  border-radius: 10px;\n  line-height: 1.4;\n}\n\n.connectionActions {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.disconnectBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #c53030;\n  background: #fff5f5;\n  border: 1px solid #fed7d7;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.disconnectBtn:hover {\n  background: #fff0f0;\n  border-color: #fc8181;\n}\n\n/* ------------------------------------------------------------------ */\n/* Available providers grid                                            */\n/* ------------------------------------------------------------------ */\n\n.providerGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 12px;\n}\n\n.providerCard {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  transition: border-color 0.15s ease;\n}\n\n.providerCard:hover {\n  border-color: #cbd5e0;\n}\n\n.providerIconWrap {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.providerIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.providerIconFallback {\n  color: #a0aec0;\n}\n\n.providerBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.providerName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 6px;\n}\n\n.providerScopes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.connectBtn {\n  flex-shrink: 0;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #4299e1;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n\n.connectBtn:hover {\n  background: #3182ce;\n}\n\n/* ------------------------------------------------------------------ */\n/* Footnote                                                            */\n/* ------------------------------------------------------------------ */\n\n.footnote {\n  margin-top: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 12px;\n  color: #718096;\n  line-height: 1.55;\n  padding: 10px 12px;\n  background: #f7fafc;\n  border-radius: 6px;\n}\n\n.footnote svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #a0aec0;\n}\n\n/* ------------------------------------------------------------------ */\n/* Responsive                                                          */\n/* ------------------------------------------------------------------ */\n\n@media (max-width: 640px) {\n  .container {\n    padding: 16px;\n  }\n\n  .connectionCard {\n    flex-wrap: wrap;\n  }\n\n  .connectionActions {\n    width: 100%;\n    justify-content: flex-end;\n    margin-top: 8px;\n  }\n\n  .providerGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .providerCard {\n    flex-wrap: wrap;\n  }\n\n  .connectBtn {\n    width: 100%;\n    margin-top: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OAuthConnections_container__Te2Od`,
	"headerRow": `OAuthConnections_headerRow__0VAEl`,
	"title": `OAuthConnections_title__FH-yz`,
	"subtitle": `OAuthConnections_subtitle__dCm8t`,
	"loadingBlock": `OAuthConnections_loadingBlock__QNCvQ`,
	"spin": `OAuthConnections_spin__t38JN`,
	"oauthSpin": `OAuthConnections_oauthSpin__tOqFj`,
	"section": `OAuthConnections_section__yYNXj`,
	"sectionTitle": `OAuthConnections_sectionTitle__X-Un-`,
	"emptyHint": `OAuthConnections_emptyHint__7ITH0`,
	"connectionList": `OAuthConnections_connectionList__mDOtB`,
	"connectionCard": `OAuthConnections_connectionCard__THEBo`,
	"connectionIconWrap": `OAuthConnections_connectionIconWrap__CDd-r`,
	"connectionIcon": `OAuthConnections_connectionIcon__WjQ3m`,
	"connectionIconFallback": `OAuthConnections_connectionIconFallback__aKUdO`,
	"connectionBody": `OAuthConnections_connectionBody__LQ+zh`,
	"connectionLine1": `OAuthConnections_connectionLine1__C8Y8v`,
	"connectionAccount": `OAuthConnections_connectionAccount__q4gbC`,
	"badgeApp": `OAuthConnections_badgeApp__5rG1p`,
	"badgeTenant": `OAuthConnections_badgeTenant__ytjoY`,
	"connectionLine2": `OAuthConnections_connectionLine2__92bbS`,
	"connectionLine3": `OAuthConnections_connectionLine3__LnM8P`,
	"dot": `OAuthConnections_dot__gImRy`,
	"scopesRow": `OAuthConnections_scopesRow__YeRmL`,
	"scopeChip": `OAuthConnections_scopeChip__D7Up6`,
	"scopeChipMuted": `OAuthConnections_scopeChipMuted__paUUX`,
	"connectionActions": `OAuthConnections_connectionActions__3usvt`,
	"disconnectBtn": `OAuthConnections_disconnectBtn__zwfnV`,
	"providerGrid": `OAuthConnections_providerGrid__LyaFU`,
	"providerCard": `OAuthConnections_providerCard__eHXLh`,
	"providerIconWrap": `OAuthConnections_providerIconWrap__sjNMd`,
	"providerIcon": `OAuthConnections_providerIcon__HKPSH`,
	"providerIconFallback": `OAuthConnections_providerIconFallback__wNsZd`,
	"providerBody": `OAuthConnections_providerBody__gMBEX`,
	"providerName": `OAuthConnections_providerName__dGYOI`,
	"providerScopes": `OAuthConnections_providerScopes__Gdmsr`,
	"connectBtn": `OAuthConnections_connectBtn__MApsi`,
	"footnote": `OAuthConnections_footnote__cSP8K`
};
export default ___CSS_LOADER_EXPORT___;
